<span class="data-table__content">
    <ng-container *ngIf="params.popoverTriggerType === 'ellipsis'">
        <span class="popover-label-margin">{{params.popoverLabel}}</span>
        <ng-container *ngTemplateOutlet="popoverTemplate;context:{params: params}">
        </ng-container>
    </ng-container>

    <ng-container *ngIf="params.popoverTriggerType === 'text'" >
        <ng-container *ngTemplateOutlet="popoverTemplate;context:{params: params}">
        </ng-container>
    </ng-container>

    <ng-template #popoverTemplate let-params="params">
        <lib-popover
        [popoverLabel]="params.popoverLabel"
        [popoverTitle]="params.popoverTitle"
        [popoverType]="params.popoverTriggerType"
        [popoverPlacement]="params.popoverPlacement">
        <hr class="popover-content-hr">
        <ng-container *ngIf="params.popoverContent">
            <div [innerHtml]="params.popoverContent"></div>
        </ng-container>
        <ng-container *ngIf="params.isTextPopover">
            <span>{{params.popoverText}}</span>
        </ng-container>
        <ng-container *ngIf="params.isLinksPopover">
            <div *ngFor="let link of params.links; let i=index;" class="links-popover-margin">
                <div *ngIf="link.isDisabled" [title]="link.disabledTooltipText">{{link.displayValue}}</div>
                <a *ngIf="!link.isDisabled" [href]="link.href">{{link.displayValue}}</a>
            </div>
        </ng-container>
    </lib-popover>
    </ng-template>
</span>
